export const OfferUnsubscribeViewStyles = {
  unsubscribeMessage:
    'my-5 text-xl font-regular text-goEasyGray900 text-center sm:text-left',
}
